import React, { useState } from 'react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Stack, Inline } from '@atlaskit/primitives/compiled';

import { TimeRangeSelector, type TimeRange } from './TimeRangeSelector.tsx';

const styles = cssMap({
	container: {
		width: '100%',
		marginBlockStart: token('space.300'),
	},
});

type LoadTimesTabProps = {
	// TODO: Add props as needed
};

export const LoadTimesTab = (_props: LoadTimesTabProps) => {
	const [selectedRange, setSelectedRange] = useState<TimeRange>('7d');

	return (
		<Stack xcss={styles.container}>
			<Inline alignBlock="center" spread="space-between">
				<TimeRangeSelector selectedRange={selectedRange} onChange={setSelectedRange} />
			</Inline>
			{/* TODO: Add tab content components */}
			{/* selectedRange is available here to pass to future content components */}
		</Stack>
	);
};
